import React from 'react';
import { assetUrl } from '~/helpers';
import useCurrentUser from '~/react-hooks/use-current-user';
import {
  Button,
  ButtonShape,
  ButtonSize,
  ButtonVariant,
} from '@vimily/bonjoro-ui-components-v2/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCreditCard } from '~/App/Modules/NewBilling/Hooks/useCreditCard';
import { Modal } from '@vimily/bonjoro-ui-components-v2/Modal';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import cx from 'classnames';

export interface StripePaymentModalProps {
  open: boolean;
  loading?: boolean;
  amount?: number;
  onCloseClick: () => void;
  onSubmitClick: () => void;
}

export function StripePaymentModal({
  open,
  loading = false,
  amount = 0,
  onCloseClick,
  onSubmitClick,
}: StripePaymentModalProps) {
  const { email } = useCurrentUser();

  const { data: card, isLoading: isCardDetailsLoading } = useCreditCard({});

  const ctaDisabled = isCardDetailsLoading || loading;

  const onSubmitClickHandler = () => {
    if (loading) return;
    onSubmitClick();
  };

  return (
    <Modal
      open={open}
      onModalClose={onCloseClick}
      closeButtonClassName={cx([
        '!top-6 !right-6 border border-solid v2-border-neutral-300',
        '!w-3 !h-3 p-[0.15rem] rounded-full',
      ])}
      className='w-auto h-auto !inset-px !p-0'
    >
      <div className='flex flex-col bg-neutral-200 border-solid border-0 border-b border-neutral-300 rounded-t'>
        <div className='flex justify-center -mt-6'>
          <img
            className='bg-white border-4 border-solid border-white rounded-full shadow-2xl'
            width={70}
            src={assetUrl('assets/images/logos/bear-logo.png')}
            alt='Bonjoro logo'
          />
        </div>
        <h4
          className='self-center w-full text-center border-solid border-0 border-b border-neutral-300 pb-1.5 mt-3.5'
          style={{ maxWidth: 174 }}
        >
          Bonjoro
        </h4>
        <p className='text-center text-xs text-neutral-500'>{email}</p>
      </div>
      <div className='p-8'>
        {card && (
          <div className='flex mb-[30px] gap-x-4 justify-between'>
            <i className={`text-[2.25rem] fab fa-cc-${card?.brand}`} />
            <div className='ml-0 flex flex-col gap-y-1 text-xs'>
              <div>XXXX XXXX XXXX {card?.last4}</div>
              <div>
                {card?.exp_month} / {card?.exp_year}
              </div>
            </div>
          </div>
        )}
        <Button
          className='confirm-payment w-full !py-1.5'
          size={ButtonSize.Small}
          shape={ButtonShape.Round}
          variant={ButtonVariant.Primary}
          disabled={ctaDisabled}
          onClick={onSubmitClickHandler}
        >
          {loading && <FontAwesomeIcon className='spinning' icon={faSpinner} />}
          {!loading && `Pay $${amount}`}
        </Button>
      </div>
    </Modal>
  );
}
